__turbopack_context__.v({
  "highlight": "BoardSectionTitle-module-scss-module__USqgbW__highlight",
  "title": "BoardSectionTitle-module-scss-module__USqgbW__title",
  "wrapper": "BoardSectionTitle-module-scss-module__USqgbW__wrapper",
});
